<template>
  <div>
    <el-row>
      <el-col :span="24" style="display: flex; justify-content: center">
        <el-button
          style="padding: 12px; display: inline-block; margin: 0 11px"
          @click="toNavi(-1)"
          type="primary"
          >《《</el-button
        >
        <el-date-picker v-model="dateVal" type="date" placeholder="选择日期">
        </el-date-picker>
        <el-button
          style="padding: 12px; display: inline-block; margin: 0 11px"
          @click="toNavi(1)"
          type="primary"
          >》》</el-button
        >
      </el-col>
    </el-row>
    <div>
      <el-divider></el-divider>
      <el-button type="primary"   v-has-permission-code-and="'100000150090'" size="small " @click="dyList(2)" round   
        >数据新增清单</el-button
      > <el-button type="success" size="small " @click="dyList(0)" round   
        >电邀上门情况</el-button
      >
      <el-row>
        <el-col :span="12">
          <div id="xzzxl" style="width: 500px; height: 400px"></div>
        </el-col>
        <el-col :span="12">
          <div id="xzzx2" style="width: 500px; height: 400px"></div>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-col :span="24">
        <div id="xzzx3" style="width: 75%; height: 300px"></div>
      </el-col>
    </el-row>
    <div>
      <el-divider></el-divider>
      <el-button type="success" size="small" @click="dyList(1)" round
       v-if="usertype>0"
        >咨询跟进情况</el-button
      >
      <el-row>
        <el-col :span="12">
          <div id="xzzx4" style="width: 45%; height: 250px"></div>
        </el-col>
        <el-col :span="12">
          <div id="xzzx5" style="width: 45%; height: 250px"></div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-divider></el-divider><el-tag size="small"  v-if="usertype==2">技术跟进次数</el-tag>
      <el-row>
        <el-col :span="24">
          <div id="xzzx6" style="width: 65%; height: 250px"></div>
        </el-col>
      </el-row>
    </div>
    <dailydylist ref="dailydylist" @flush="list()"></dailydylist>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import api from "@/api/consu/consultation/consultation.js";
import dailydylist from "./daily_dylist.vue";

export default {
  components: {
    dailydylist,
  },
  data() {
    return {
      echart1: null,
      echart2: null,
      echart3: null,
      echart4: null,
      echart5: null,
      echart6: null,
      datas: [],
      dateVal: new Date(),
      usertype: 0,
    };
  },
  mounted() {
    this.dateVal = new Date();
    this.loaddata();
  },
  methods: {
    toNavi(val) {
      let time = 0;
      if (val > 0) {
        time = this.dateVal.getTime() + 1000 * 60 * 60 * 24;
      } else {
        time = this.dateVal.getTime() - 1000 * 60 * 60 * 24;
      }

      this.$set(this, "dateVal", new Date(time));
      this.loaddata();
    },
    dyList(type) {
      let param = { type: type, day: this.dateVal.format("yyyy-MM-dd") };
      this.$refs.dailydylist.open(
        param,
        type = param.day+( 0 ? "-电邀上门清单" : ( type == 1 ? "-咨询跟进清单" :"-日新增数据"))
      );
    },
    loaddata() {
      let role = this.$caches.roleCode.get()[0];
      role = role.substring(0,2)

      if (role == "dy") {
        this.usertype = 0;
      } else if (role == "zx" || role == "qd"|| role == "zm") {
        this.usertype = 1;
      } else {
        this.usertype = 2;
      }

      api.dayConsu(
        { day: this.dateVal.format("yyyy-MM-dd") },
        (res) => {
          this.datas = res.data;
          //  console.log(this.datas)
          if (this.usertype == 0 || this.usertype == 2) {
            this.draw新增咨询量();
          }
          this.draw电邀上门率();
          if (this.usertype == 0 || this.usertype == 2) {
            this.draw电邀情况分析();
          }

          if (this.usertype == 1 || this.usertype == 2) {
            this.draw咨询情况分析();
            this.draw咨询评级分析();
          }
          if (this.usertype == 2) {
            this.draw技术跟进次数();
          }
        },
        (err) => {}
      );
    },
    draw新增咨询量() {
      this.echart1 = echarts.init(document.getElementById("xzzxl"));
      this.echart1.clear();
      if (this.datas.dayZxcount && this.datas.dayZxcount.length > 0) {
        let dataValues = this.datas.dayZxcount;
        let day = dataValues[0].day;

        this.echart1.setOption({
          title: {
            text: day,
            subtext: "新增咨询量",
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          series: [
            {
              name: "Access From",
              type: "pie",
              radius: "50%",
              data: dataValues,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} (人)",
                  },
                  labelLine: { show: true },
                },
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0.5, 0, 0.5)",
                },
              },
            },
          ],
        });
      }
    },
    draw电邀上门率() {
      this.echart2 = echarts.init(document.getElementById("xzzx2"));
      this.echart2.clear();
      if (this.datas.dayDy2SM && this.datas.dayDy2SM.length == 1) {
        let dataValues = this.datas.dayDy2SM[0];

        this.echart2.setOption({
          title: {
            text: "电邀上门情况",
            subtext: "合计" + dataValues.allcnt + "人",
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          color:[ '#CCCC33', '#006666'],
          series: [
            {
              name: "Access From",
              type: "pie",
              radius: "50%",
              data: [
                { name: "上门", value: dataValues.incnt },
                { name: "爽约", value: dataValues.allcnt - dataValues.incnt },
              ],
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} (人)",
                  },
                  labelLine: { show: true },
                },
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        });
      }
    },
    draw电邀情况分析() {
      this.echart3 = echarts.init(document.getElementById("xzzx3"));
      this.echart3.clear();
      if (this.datas.dayDyinfo) {
        let dataValues = this.datas.dayDyinfo;
        // console.log(dataValues);

        let seriesVal = [];
        for (var state in dataValues.states) {
          seriesVal.push({
            name: state,
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: dataValues.states[state],
          });
        }

        this.echart3.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow", //
            },
          },
          legend: {},
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
          },
          yAxis: {
            type: "category",
            data: dataValues.nms,
          },
          series: seriesVal,
        });
      }
    },
    draw咨询情况分析() {
      this.echart4 = echarts.init(document.getElementById("xzzx4"));
      this.echart4.clear();
      if (this.datas.dayZx) {
        let dataValues = this.datas.dayZx;

        let seriesVal = [];
        for (var state in dataValues.states) {
          seriesVal.push({
            name: state,
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: dataValues.states[state],
          });
        }

        this.echart4.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow", //
            },
          },
          legend: {},
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
          },
          yAxis: {
            type: "category",
            data: dataValues.nms,
          },
          series: seriesVal,
        });
      }
    },
    draw咨询评级分析() {
      this.echart5 = echarts.init(document.getElementById("xzzx5"));
      this.echart5.clear();

      if (this.datas.dayZxRank) {
        let dataValues = this.datas.dayZxRank;

        let seriesVal = [];
        for (var state in dataValues.states) {
          seriesVal.push({
            name: state,
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: dataValues.states[state],
          });
        }

        this.echart5.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow", //
            },
          },
          legend: {},
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
          },
          yAxis: {
            type: "category",
            data: dataValues.nms,
          },
          series: seriesVal,
        });
      }
    },
    draw技术跟进次数() {
      this.echart6 = echarts.init(document.getElementById("xzzx6"));
      this.echart6.clear();

      if (this.datas.dayTeach) {
        let dataValues = this.datas.dayTeach;

        let seriesVal = [];
        for (var state in dataValues.states) {
          seriesVal.push({
            name: state,
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: dataValues.states[state],
          });
        }

        this.echart6.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow", //
            },
          },
          legend: {},
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
          },
          yAxis: {
            type: "category",
            data: dataValues.nms,
          },
          series: seriesVal,
        });
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>